<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Nome Caixa</span>
          <vs-input class="w-full" name="Nome Caixa" id="Nome Caixa" v-model="formCadastro.nomeCaixa"
            v-validate="{ required: true, min: 6 }" :state="utilsList.validateState(
              this.veeFields,
              this.veeErrors,
              'Nome Caixa'
            )
              " :danger="!utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Nome Caixa'
              )
                " val-icon-danger="clear" danger-text="Preencha este Campo" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Descrição</span>
          <vs-input class="w-full" name="Descrição" id="Descrição" v-model="formCadastro.descricao"
            v-validate="{ required: true, min: 6 }" :state="utilsList.validateState(
              this.veeFields,
              this.veeErrors,
              'Descrição'
            )
              " :danger="!utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Descrição'
              )
                " val-icon-danger="clear" danger-text="Preencha este Campo" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Tipo</span>

          <v-select :options="tipos" name="Tipo" id="Tipo" :reduce="(Tipo) => Tipo.id"
            v-model="formCadastro.idTipo"></v-select>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Marca ou Personalidade</span>

          <v-select :options="marcas" name="Marca ou Personalidade" id="Marca ou Personalidade"
            :reduce="(Tipo) => Tipo.id" v-model="formCadastro.idPersonalidade"></v-select>
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/1 w-full">
          <span>Link da Caixa</span>
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-primary">
                <span>{{ getRouter() }}</span>
              </div>
            </template>

            <vs-input v-model="formCadastro.urlCaixa" id="Link da Caixa" name="Link da Caixa"
              v-validate="{ required: true, min: 3 }" @keyup="mascaraLoja($event)" :state="utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Link da Caixa'
              )
                " :danger="!utilsList.validateState(
                  this.veeFields,
                  this.veeErrors,
                  'Link da Caixa'
                )
                  " />
          </vx-input-group>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col mb-6">
          <label for="corHexa">Cor</label>
          <div class="input-group-color">
            <input type="color" size="large" class="w-full color-picker" name="corHexa" id="corHexa"
              v-on:change="changeThemeColor" v-model="formCadastro.corHexa" v-validate="{ required: false }"
              :state="validateState('corHexa')" :danger="validateClass('corHexa')" val-icon-danger="clear"
              danger-text="Preencha este Campo" icon-no-border />
            <vs-input class="w-full" name="corHexa" id="corHexa" @keyup.native="changeThemeColor"
              v-model="formCadastro.corHexa" v-validate="{ required: false }" :state="validateState('corHexa')"
              :danger="validateClass('corHexa')" val-icon-danger="clear" danger-text="Preencha este Campo"
              icon-no-border />
          </div>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Valor</span>
          <money class="w-full vs-inputx vs-input--input large" name="Valor" id="Valor" v-model="formCadastro.valor"
            v-validate="{ required: true }" :state="utilsList.validateState(this.veeFields, this.veeErrors, 'Valor')
              " :danger="!utilsList.validateState(this.veeFields, this.veeErrors, 'Valor')
                " v-bind="money"></money>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Valor Promoção</span>
          <money class="w-full vs-inputx vs-input--input large" name="valorPromocao" id="valorPromocao"
            v-model="formCadastro.valorPromocao" v-validate="{ required: true }" :state="utilsList.validateState(this.veeFields, this.veeErrors, 'valorPromocao')
              " :danger="!utilsList.validateState(this.veeFields, this.veeErrors, 'valorPromocao')
                " v-bind="money"></money>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/1 w-full">
          <div>Imagem (190 x 230)</div>
          <center v-if="formCadastro.imagem">
            <img :src="formCadastro.imagem" width="100%" style="max-width: 190px" />
          </center>
          <input id="fileUpload" type="file" hidden v-on:change="selecionaImagem" />
          <vs-button color="warning" type="border" class="mr-3 text-center" @click.stop.prevent="chooseFiles()">
            Escolher uma Imagem
            <feather-icon icon="UploadIcon" class="ml-2" />
            <Br />
            <vs-chip v-if="imagem" class="mt-3">
              <vs-avatar icon-pack="feather" icon="icon-file" />
              <span>{{ imagem }}</span>
            </vs-chip>
          </vs-button>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/1 w-full">
          <div>Banner (1900 x 450)</div>
          <center v-if="formCadastro.banner">
            <img :src="formCadastro.banner" width="100%" style="max-width: 190px" />
          </center>
          <input id="fileUpload2" type="file" hidden v-on:change="selecionaBanner" />
          <vs-button color="warning" type="border" class="mr-3 text-center" @click.stop.prevent="chooseFiles2()">
            Escolher uma Imagem
            <feather-icon icon="UploadIcon" class="ml-2" />
            <Br />
            <vs-chip v-if="banner" class="mt-3">
              <vs-avatar icon-pack="feather" icon="icon-file" />
              <span>{{ banner }}</span>
            </vs-chip>
          </vs-button>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/1 w-full">
          <div>Banner Mobile (390 x 450)</div>
          <center v-if="formCadastro.bannerMobile">
            <img :src="formCadastro.bannerMobile" width="100%" style="max-width: 190px" />
          </center>
          <input id="fileUpload3" type="file" hidden v-on:change="selecionaBannerMobile" />
          <vs-button color="warning" type="border" class="mr-3 text-center" @click.stop.prevent="chooseFiles3()">
            Escolher uma Imagem
            <feather-icon icon="UploadIcon" class="ml-2" />
            <Br />
            <vs-chip v-if="bannerMobile" class="mt-3">
              <vs-avatar icon-pack="feather" icon="icon-file" />
              <span>{{ bannerMobile }}</span>
            </vs-chip>
          </vs-button>
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <span>Ordenação</span>
          <vs-input class="w-full" name="Ordenação" id="Ordenação" type="number" v-model="formCadastro.ordenacao"
            v-validate="{ required: true }" :state="utilsList.validateState(
              this.veeFields,
              this.veeErrors,
              'Ordenação'
            )
              " :danger="!utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Ordenação'
              )
                " val-icon-danger="clear" danger-text="Preencha este Campo" />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Destaque</span>
          <vs-switch color="success" v-model="formCadastro.destaque" style="width: 60px">
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Nova</span>
          <vs-switch color="success" v-model="formCadastro.caixaNova" style="width: 60px">
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Completa</span>
          <vs-switch color="success" v-model="formCadastro.caixaCompleta" style="width: 60px">
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Desconto</span>
          <vs-switch color="success" v-model="formCadastro.desconto" style="width: 60px">
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch color="success" v-model="formCadastro.status" style="width: 60px">
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <vs-alert v-if="$validator.errors.all().length > 0" color="danger" title="Atenção!!" active="true" class="my-3"
        style="height: auto !important">
        <ul>
          <li class="mb-2" v-for="error in $validator.errors.all()" :key="error.id">
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button color="warning" type="border" class="mr-3 mb-2" @click.stop.prevent="onReset">Cancelar</vs-button>
          <BotaoSubmit variant="success" :edit="this.dados.idCaixa == null ? false : true" :aguarde="aguardeCadastro">
          </BotaoSubmit>
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from "../../../../locale";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import vSelect from "vue-select";
import service from "../../../../services";
import BotaoSubmit from "../../../../components/BotaoSubmit";
import utilsList from "../../../../utils/list";
import cpfCnpj from "../../../../services/cpfCnpj";
import { Money } from "v-money";
export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    contadorRender: {
      type: Number,
    },
  },
  watch: {
    dados(value) {
      this.preencheForm();
    },
    contadorRender(value) {
      this.preencheForm();
    },
  },
  data() {
    return {
      utilsList,
      aguardeCadastro: false,
      situacoes: ["Ativo", "Inativo"],
      languages: lang,
      funcoesValicao: null,
      files: new FormData(),
      imagem: null,
      banner: null,
      bannerMobile: null,
      tipos: [],
      marcas: [],
      temaCor: {},
      formCadastro: {
        idCaixa: null,
        nomeCaixa: null,
        status: true,
        imagem: null,
        corHexa: null,
        destaque: null,
        banner: null,
        bannerMobile: null,
        urlCaixa: null,
        idTipo: null,
        idPersonalidade: null,
        valor: null,
        valorPromocao: null,
        caixaNova: null,
        caixaCompleta: null,
        ordenacao: null,
        descricao: null,
        desconto: null,
      },
    };
  },
  methods: {
    getRouter() {
      //console.log(this.$router.currentRoute);
      var url = window.location.origin;
      if (url.indexOf("homologacao") >= 0 || url.indexOf("localhost") >= 0)
        return window.location.origin + "/";
      else return "https://boxdasorte.com/";
    },
    mascaraLoja(event) {
      const input = event.target;
      input.value = input.value
        .replace(/[~`!@#$%^&*()+={}\[\];:\'\"<>.,\/\\\?_]/g, "")
        .replace(new RegExp(" ", "g"), "-")
        .replace(new RegExp("á", "g"), "a")
        .replace(new RegExp("â", "g"), "a")
        .replace(new RegExp("à", "g"), "a")
        .replace(new RegExp("â", "g"), "a")
        .replace(new RegExp("é", "g"), "e")
        .replace(new RegExp("ê", "g"), "e")
        .replace(new RegExp("è", "g"), "e")
        .replace(new RegExp("í", "g"), "i")
        .replace(new RegExp("î", "g"), "i")
        .replace(new RegExp("ì", "g"), "i")
        .replace(new RegExp("ó", "g"), "o")
        .replace(new RegExp("õ", "g"), "o")
        .replace(new RegExp("ò", "g"), "o")
        .replace(new RegExp("ô", "g"), "o")
        .replace(new RegExp("ú", "g"), "u")
        .replace(new RegExp("û", "g"), "u")
        .replace(new RegExp("ì", "g"), "u")
        .replace(new RegExp("ç", "g"), "c");
    },
    retornaMascara(valor) {
      return valor
        .replace(/[~`!@#$%^&*()+={}\[\];:\'\"<>.,\/\\\?_]/g, "")
        .replace(new RegExp(" ", "g"), "-")
        .replace(new RegExp("á", "g"), "a")
        .replace(new RegExp("â", "g"), "a")
        .replace(new RegExp("à", "g"), "a")
        .replace(new RegExp("â", "g"), "a")
        .replace(new RegExp("é", "g"), "e")
        .replace(new RegExp("ê", "g"), "e")
        .replace(new RegExp("è", "g"), "e")
        .replace(new RegExp("í", "g"), "i")
        .replace(new RegExp("î", "g"), "i")
        .replace(new RegExp("ì", "g"), "i")
        .replace(new RegExp("ó", "g"), "o")
        .replace(new RegExp("õ", "g"), "o")
        .replace(new RegExp("ò", "g"), "o")
        .replace(new RegExp("ô", "g"), "o")
        .replace(new RegExp("ú", "g"), "u")
        .replace(new RegExp("û", "g"), "u")
        .replace(new RegExp("ì", "g"), "u")
        .replace(new RegExp("ç", "g"), "c");
    },
    changeThemeColor(event) {
      const { value, name } = event.target;
      this.formCadastro.corHexa = value;
    },
    chooseFiles() {
      document.getElementById("fileUpload").click();
      //this.$refs.fileUploadBtn.click();
      console.log(document.getElementById("fileUpload"));
    },
    chooseFiles2() {
      document.getElementById("fileUpload2").click();
      //this.$refs.fileUploadBtn.click();
      console.log(document.getElementById("fileUpload2"));
    },
    chooseFiles3() {
      document.getElementById("fileUpload3").click();
      //this.$refs.fileUploadBtn.click();
      console.log(document.getElementById("fileUpload3"));
    },
    selecionaImagem(event) {
      console.log(event);
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      console.log(files[0]);
      this.files.set("file", event.target.files[0], event.target.files[0].name);
      this.imagem = event.target.files[0].name;

      this.$vs.loading();
      service
        .upload("Upload", "Caixa", this.files)
        .then((response) => {
          this.formCadastro.imagem = response;
          console.log(response);
          this.$vs.loading.close();
          //this.onSubmit();
        })
        .catch((error) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: error,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    selecionaBanner(event) {
      console.log(event);
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      console.log(files[0]);
      this.files.set("file", event.target.files[0], event.target.files[0].name);
      this.banner = event.target.files[0].name;

      this.$vs.loading();
      service
        .upload("Upload", "Caixa", this.files)
        .then((response) => {
          this.formCadastro.banner = response;
          console.log(response);
          this.$vs.loading.close();
          //this.onSubmit();
        })
        .catch((error) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: error,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    selecionaBannerMobile(event) {
      console.log(event);
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      console.log(files[0]);
      this.files.set("file", event.target.files[0], event.target.files[0].name);
      this.bannerMobile = event.target.files[0].name;

      this.$vs.loading();
      service
        .upload("Upload", "Caixa", this.files)
        .then((response) => {
          this.formCadastro.bannerMobile = response;
          console.log(response);
          this.$vs.loading.close();
          //this.onSubmit();
        })
        .catch((error) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: error,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    preencheForm() {
      if (this.dados.idCaixa) {
        this.formCadastro.idCaixa = this.dados.idCaixa;
        this.formCadastro.nomeCaixa = this.dados.nomeCaixa;
        this.formCadastro.imagem = this.dados.imagem;
        this.formCadastro.corHexa = this.dados.corHexa;
        this.formCadastro.destaque = this.dados.destaque;
        this.formCadastro.banner = this.dados.banner;
        this.formCadastro.bannerMobile = this.dados.bannerMobile;
        this.formCadastro.urlCaixa = this.dados.urlCaixa;
        this.formCadastro.idTipo = this.dados.idTipo;
        this.formCadastro.idPersonalidade = this.dados.idPersonalidade;
        this.formCadastro.valor = this.dados.valor;
        this.formCadastro.valorPromocao = this.dados.valorPromocao;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
        this.formCadastro.ordenacao = this.dados.ordenacao;
        this.formCadastro.caixaNova = this.dados.caixaNova;
        this.formCadastro.caixaCompleta = this.dados.caixaCompleta;
        this.formCadastro.desconto = this.dados.desconto;
        this.formCadastro.descricao = this.dados.descricao;

        this.imagem = this.dados.imagem;
        this.banner = this.dados.banner;
        this.bannerMobile = this.dados.bannerMobile;
      } else {
        this.resetForm();
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    onSubmit() {
      var action = "Atualizar/" + this.formCadastro.idCaixa;
      var metodo = "put";
      var msgRetorno = "Dados Atualizados com sucesso";
      if (!this.formCadastro.idCaixa) {
        action = "Adicionar";
        metodo = "post";
        msgRetorno = "Caixa Adicionado com sucesso";
      }

      var objSend = { ...this.formCadastro };

      objSend.urlCaixa = this.retornaMascara(objSend.urlCaixa);
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service[metodo]("Caixa", action, objSend)
            .then((res) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: `Operação Realizada com sucesso`,
                color: "success",
              });
              this.$emit("concluido");
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: error,
                color: "danger",
              });
            });
        }
      });
    },

    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll("g", {}, `${model}/list`).then((res) => {
        res.data.forEach((element) => {
          if (element.deletedAt == null)
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
        console.log(this.regionais);
      });
    },
    resetForm() {
      this.formCadastro = {
        idCaixa: null,
        nomeCaixa: null,
        status: true,
        imagem: null,
        corHexa: null,
        destaque: null,
        banner: null,
        bannerMobile: null,
        urlCaixa: null,
        idTipo: null,
        idPersonalidade: null,
        valor: null,
        caixaCompleta: null,
        caixaNova: null,
        ordenacao: null,
      };
    },
    onReset(evt) {
      this.$emit("cancel");

      this.resetForm();
    },
  },
  created() {
    this.buscaDadosSelects("tiposCaixa", "tipos", "nomeTipo", "idTipo");
    this.buscaDadosSelects(
      "marcasPersonalidades",
      "marcas",
      "nome",
      "idPersonalidade"
    );
    this.$validator.localize("ptBr", locale);
  },
  components: {
    Datepicker,
    BotaoSubmit,
    "v-select": vSelect,
    Money,
  },
};
</script>
<!------------ END SCRIPT ------------>
<style scoped>
#fileInput {
  display: none;
}

.img label {
  width: 100%;
  font-weight: normal;
}

.img .containericone {
  text-align: center;
  border-radius: 10px;
  padding: 10px 20px;
  -webkit-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  width: min-content;
  margin-top: 25px;
  margin-left: 43%;
  border: 1px solid #ccc;
}

.img .icone {
  font-size: 50px;
  color: #333;
}

.input-group-color {
  display: flex !important;
  gap: 5px;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.color-picker {
  max-width: 2.5rem;
  height: 2.375rem;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 4px;
}
</style>
